module.exports = __webpack_public_path__ + "static/media/play.72116943.svg";